var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapExpand(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1233,
    height: 1187,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2896,
    y: 18,
    width: 1233,
    height: 1187
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3726.03 420.855 4127.33 751.044 3756.89 1201.27 3355.58 871.086Z",
    fillRule: "nonzero",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3726.03 420.855 4127.33 751.044 3756.89 1201.27 3355.58 871.086Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3552.05-208.513 4380.13 472.823 3534.45 1500.65 2706.37 819.316Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3290.53 804.555 2899.75 461.977 3284.09 23.5523 3674.88 366.131Z",
    fillRule: "nonzero",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3290.53 804.555 2899.75 461.976 3284.09 23.5521 3674.88 366.131Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3444.74 1439.06 2638.37 732.155 3515.78-268.722 4322.16 438.18Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-2896 -18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2927 604.5C2927 281.69 3188.91 19.9999 3512 19.9999 3835.09 19.9999 4097 281.69 4097 604.5 4097 927.31 3835.09 1189 3512 1189 3188.91 1189 2927 927.31 2927 604.5Z",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.807 569.991 913.893 569.991 814.532 669.351C801.577 682.306 801.577 703.311 814.532 716.267 827.488 729.222 848.493 729.222 861.448 716.267L1017.72 559.948C1030.68 547.61 1031.18 527.105 1018.84 514.15 1018.48 513.769 1018.1 513.396 1017.72 513.033L861.414 356.759C849.076 343.804 828.571 343.304 815.616 355.642 815.235 356.005 814.862 356.378 814.499 356.759 801.544 369.098 801.043 389.603 813.382 402.558 813.745 402.939 814.118 403.312 814.499 403.675L913.859 503.091 78.807 503.091C60.2993 503.091 45.2959 518.094 45.2959 536.602 45.2959 555.111 60.2993 570.113 78.807 570.113Z",
    fill: "#404040",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(0.772213 0.635364 -0.78862 0.958478 3552.05 -208.513)"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.807 569.991 913.893 569.991 814.532 669.351C801.577 682.306 801.577 703.311 814.532 716.267 827.488 729.222 848.493 729.222 861.448 716.267L1017.72 559.948C1030.68 547.61 1031.18 527.105 1018.84 514.15 1018.48 513.769 1018.1 513.396 1017.72 513.033L861.414 356.759C849.076 343.804 828.571 343.304 815.616 355.642 815.235 356.005 814.862 356.378 814.499 356.759 801.544 369.098 801.043 389.603 813.382 402.558 813.745 402.939 814.118 403.312 814.499 403.675L913.859 503.091 78.807 503.091C60.2993 503.091 45.2959 518.094 45.2959 536.602 45.2959 555.111 60.2993 570.113 78.807 570.113Z",
    fill: "#404040",
    fillRule: "nonzero",
    fillOpacity: 1,
    transform: "matrix(-0.751964 -0.659205 0.818211 -0.933344 3444.74 1439.06)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapExpand);
export default __webpack_public_path__ + "static/media/map-expand.95f78573f435d957265506eea42b269c.svg";
export { ForwardRef as ReactComponent };